import * as request from "../utils/request"
import * as helper from "../utils/helper"
import * as aes from "../utils/aes"
import * as ua from "../utils/ua"
import * as langs from "../constants/langs"
import * as modals from "../constants/modals"
import * as gamePropsAPI from "../api/gameProps"
import { getParam } from "../utils/url"
import "es6-promise/auto"
import { BUSINESS_TYPE } from "../store/enums"
import { checkFilterStoreConfigBiz } from "../api/store-config"

const commonParams = {
  pfkey: "pfkey",
  from_https: 1,
  from_h5: 1
}

/**
 * 搜索关键字
 * 从后台读取获得显示列表
 */
export function recommend(params) {
  return new Promise((resolve, reject) => {
    let apiParams = {
      cmd: 26
    }

    let env = helper.getCgiEnv(params.sandbox),
      data = helper.extend(
        apiParams,
        commonParams,
        params,
        aes.encrypt(apiParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
      )

    delete data.sandbox

    request
      .ajax({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + (params.offerId || "1450000186") + "/wechat_query",
        data: data,
        type: "post"
      })
      .then(res => {
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
  })
}

/**
 * camll_query，抽成可复用的调用
 * @param cmd
 * @param params
 * @returns {Promise<unknown>}
 */
export function cmallQuery(cmd, params) {
  return new Promise((resolve, reject) => {
    let apiParams = {
      cmd
    }

    // cmallquery查推荐不支持第三方登录态，目前有场景：快手内打开王者商城，故使用游客登录态查
    if (params.session_type == "st_local_third_party") {
      params = {
        ...params,
        openid: "openid",
        openkey: "openkey",
        session_id: "hy_gameid",
        session_type: "st_dummy"
      }
    }

    let env = helper.getCgiEnv(params.sandbox),
      data = helper.extend(
        apiParams,
        commonParams,
        params,
        aes.encrypt(apiParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
      )

    delete data.sandbox

    request
      .ajax({
        // url: "http://9.84.218.74/cgi-bin/cmall_query.fcg",
        url: "//" + env + "api.unipay.qq.com/v1/r/" + (params.offerId || "1450000186") + "/cmall_query",
        data: {
          ...data,
          offer_id: params.offerId || "1450000186"
        },
        type: "post"
      })
      .then(res => {
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
  })
}

/**
 * cmallquery调用推荐流程
 * @param params
 * @returns {Promise<unknown>}
 */
export function cmallQueryRecommend(params) {
  return cmallQuery("recommend_info", params)
}

/**
 * cmallquery判断iOS是否放开现金充值渠道
 * 一期放开为3、4线城市+ip防控白名单
 * @param params
 * @returns {Promise<unknown>}
 */
export function cmallQueryIosWhitelist(params) {
  return cmallQuery("ios_whitelist", params)
}

export function getOSAccount(params) {
  let userAgent = ua.getUserAgent(),
    os = "",
    account

  if (userAgent.iOS) {
    os = "ios"
  } else {
    os = "android"
  }

  if (
    params.loginState.session_id == "uin" ||
    params.loginState.session_type == "kp_actoken" ||
    params.loginState.session_type == "kp_accesstoken"
  ) {
    account = "qq"
  } else if (params.loginState.session_id == "hy_gameid") {
    account = "wx"
  }

  return { os, account }
}

/**
 * 热搜（大家都在搜）
 * @param params
 */
export function getHotSearchRecommend(params) {
  let { os, account } = getOSAccount(params)

  return recommend({
    pf: params.pf,
    model: `${modals.HOT_SEARCH.PREFIX}${account}-${os}`,
    sandbox: params.sandbox,
    ...params.loginState
  })
}

export function getBackpackHeroRecommend(params) {
  return recommend({
    pf: params.pf,
    model: "wzry_hero_recommend",
    sandbox: params.sandbox,
    ...params.loginState
  })
}

/**
 * 推荐IPzone的专区顺序
 * @param params.loginState
 * @param params.pf
 * @param params.sandbox
 */
export function getIpZoneSortRecommend(params) {
  return recommend({
    pf: params.pf,
    model: modals.IP_ZONE.IP_ZONE_SORT,
    sandbox: params.sandbox,
    ...params.loginState
  })
}

/**
 * 推荐列表页展示的泛娱乐专区入口
 * @param params.loginState
 * @param params.pf
 * @param params.sandbox
 */
export function getIpZoneVipListRecommend(params) {
  return recommend({
    pf: params.pf,
    model: modals.IP_ZONE.VIP_LIST_IP_ZONE,
    sandbox: params.sandbox,
    ...params.loginState
  })
}

/**
 * 用户搜关键字获得相应的服务列表
 * @param params
 */
export function getKeywordSearchRecommend(params) {
  const urlModal = getParam("modal_search")

  return recommend({
    pf: params.pf,
    model: urlModal ? urlModal : modals.SEARCH.SEARCH_NEW,
    sandbox: params.sandbox,
    ext: encodeURIComponent("keyword=" + helper.base64encode(helper.handleRecommTxt(params.ext))),
    ...params.loginState
  })
}

export function getGoodsItemIdRecommend(params) {
  return recommend({
    pf: params.pf,
    model: params.model,
    sandbox: params.sandbox,
    ...params.loginState
  })
}

/**
 * 根据模型获得推荐结果
 * 其实上面我看有写也可以用这个方法，该方法为通用方法
 * 传入modals，获得模型推荐
 * @param params
 */
export function getRecommendByModel(params) {
  return recommend({
    pf: params.pf,
    model: params.model,
    sandbox: params.sandbox,
    ...helper.getLoginState(params.loginState)
  })
}

/**
 * 首页常用业务推荐
 * @param params
 */
export function getIndexServicesRecommend(params) {
  let userAgent = ua.getUserAgent(),
    model = ""
  let { os, account } = getOSAccount(params)

  // ios 下，浏览器等外部入口，可以用安卓的推荐
  if (userAgent.iOS && !(userAgent.weixin || userAgent.QQ || userAgent.inApp)) {
    os = "android"
  }

  model = `index_recomm_new_${os}_${account}`

  if (langs.WALLET_WECHAT_STORE_PF.indexOf(params.pf) == -1 && userAgent.iOS && account == "wx") {
    model = model + "_woap"
  }

  model = params.isHotModel ? `${model}_hot` : model

  return recommend({
    pf: `${params.pfSource}-${params.pf}-html5`,
    model: model,
    sandbox: params.sandbox,
    ...params.loginState
  })
}

/**
 * 处理列表推荐的结果
 * 多处需要这么处理，故抽离成api
 * @param result
 * @returns {Array}
 */
export function handleRecommendResult(result) {
  let recommend_info = result.recomm_info,
    arrayResult = []

  for (let i = 1, l = Object.keys(recommend_info).length; i <= l; i++) {
    let value = recommend_info["yewu" + i]

    if (value != 0 && value !== undefined) {
      arrayResult.push(value)
    }
  }

  return arrayResult
}

/**
 * 处理道具热销推荐的结果
 * @param recomm_info
 * @returns {Array}
 */
export function handleRecomInfoResult(recommend_info) {
  let arrayResult = []

  if (recommend_info) {
    let sortArr = Object.keys(recommend_info).sort((a, b) => {
      return parseInt(a) < parseInt(b) ? -1 : 1
    })
    sortArr.forEach(key => {
      // 去重
      if (recommend_info[key] && arrayResult.indexOf(recommend_info[key]) === -1) {
        arrayResult.push(recommend_info[key])
      }
    })
  } else {
    return []
  }

  return arrayResult
}

/**
 * 从推荐中获得结果
 * 注意 item.busId == busId / not ===
 * 避免由于配置台数据结构问题导致找不到内容
 * @param itemList
 * @param recommendResult
 * @param includeCategoryId 搜索业务需要在该分类内
 * @returns {Array}
 */
export function getRecommendResultItems({
  itemList,
  recommendResult,
  excludeCategory = "",
  includeCategoryId = "",
  hideReservation = false,
  loginState = null
}) {
  let filters = []
  // let userAgent = ua.getUserAgent()
  // let isIosQQ = userAgent.iOS && userAgent.QQ

  excludeCategory = excludeCategory && excludeCategory.length > 0 ? excludeCategory : []

  recommendResult &&
    recommendResult.forEach(group => {
      if (group !== "") {
        let [gId, busId] = group.toString().split("_"),
          current = itemList[`${gId}_${busId}`]

        //过滤掉不需要展示的业务类型
        if (current) {
          if (!excludeCategory.length || excludeCategory.indexOf(current.categoryId.toString()) === -1) {
            // if (isIosQQ && current.categoryId == BUSINESS_TYPE.MOBILE_GAME) {
            //   if (!current.ios || !current.ios.qq || current.ios.qq.status != "1") {
            //     return
            //   }
            // }

            if (includeCategoryId) {
              if (
                includeCategoryId !== current.categoryId.toString() ||
                (includeCategoryId == BUSINESS_TYPE.MOBILE_GAME &&
                  includeCategoryId == current.categoryId.toString() &&
                  current.currency_type == 2)
              )
                return
            }

            // 当参数指定屏蔽预约业务hideReservation时，当业务为预约状态则过滤
            if (hideReservation && loginState) {
              let { os, account } = getOSAccount({ loginState: loginState })
              if (current[os] && current[os][account] && current[os][account].status == 2) {
                return
              }
            }

            // 过滤不在商店上架的业务
            if (checkFilterStoreConfigBiz(current)) return

            filters.push(current)
          }
        }
      }
    })

  return filters
}

/**
 * 得到了推荐列表后
 * 通过 storeConfig 找到对应的推荐
 * @param itemList
 * @param recommendResult
 * 这里根据 -1 来确定位置，-1之前为硬匹配， -1 后为推荐
 * @returns {Array}
 */
export function getConfigFromRecommend({
  itemList,
  recommendResult,
  excludeCategoryIds,
  includeCategoryId = "",
  hideReservation = false,
  loginState = null
}) {
  let match = [],
    recommend = [],
    excludeCategoryIdArr = []
  let splitIndex = recommendResult.indexOf("-1")

  if (excludeCategoryIds) {
    excludeCategoryIdArr = excludeCategoryIds.split(",")
  }

  if (splitIndex !== -1) {
    match = getRecommendResultItems({
      itemList: itemList,
      recommendResult: recommendResult.splice(0, splitIndex),
      excludeCategory: excludeCategoryIdArr,
      includeCategoryId: includeCategoryId,
      hideReservation: hideReservation,
      loginState: loginState
    })
    recommend = getRecommendResultItems({
      itemList: itemList,
      recommendResult: recommendResult,
      excludeCategory: excludeCategoryIdArr,
      includeCategoryId: includeCategoryId,
      hideReservation: hideReservation,
      loginState: loginState
    })
  } else {
    match = getRecommendResultItems({
      itemList: itemList,
      recommendResult: recommendResult,
      excludeCategory: excludeCategoryIdArr,
      includeCategoryId: includeCategoryId,
      hideReservation: hideReservation,
      loginState: loginState
    })
    recommend = []
  }
  return { match, recommend }
}

/**
 * 用户常用业务（去除实时数据的影响）
 * @param params
 */
export function checkIsWzryRecommend(params) {
  return new Promise((resolve, reject) => {
    recommend({
      pf: params.pf,
      model: modals.SERVICE_ZONE.WZRY_SMALL_ZONE,
      sandbox: params.sandbox,
      ...params.loginState
    })
      .then(res => {
        if (res.ret == 0 && res.recomm_info) {
          if (res.recomm_info.yewu1 === "2_2") {
            resolve(true)
          }
        }
        resolve(false)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * php获取资讯推荐
 * @param params
 * @returns {Promise<any>}
 * @param {String} action "getRecommendNews"获取资讯；getRecommendTagNews获取带标签资讯
 * @param {String} offerId	应用ID		透传给推荐接口
 * @param {String} cmd	命令字	26	透传给推荐接口
 * @param {String} pf	pf		透传给推荐接口
 * @param {String} model	模型ID		透传给推荐接口
 * @param {String} ext	推荐参数		透传给推荐接口
 * @param {String} openid	登录态		透传给推荐接口
 * @param {String} openkey	登录态		透传给推荐接口
 * @param {String} session_id	登录态		透传给推荐接口
 * @param {String} session_type	登录态		透传给推荐接口
 * @param {String} wx_appid	登录态		透传给推荐接口
 * @param {String} qq_appid	登录态		透传给推荐接口
 * @param {String} sandbox	环境标识	0:actual环境,1:sandbox环境,2:dev环境
 * @param {String} pageIndex	页码	>0
 * @param {String} pageSize	页长	>0 && <20
 */
export function gameRecommNews(params) {
  return new Promise((resolve, reject) => {
    var urlParams = {
      action: params.action || "getRecommendTagNews",
      cmd: 26,
      ...params
    }
    delete urlParams.url
    request
      .ajax({
        url: params.url,
        data: urlParams,
        type: "get"
      })
      .then(
        res => {
          if (res && res.ret == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 处理首页底部常用业务推荐标签
 * @param {*} recommendInfo
 * @param {*} loginState
 */
export function handleIndexRecommendInfo(recommendInfo, loginState) {
  let accountType = helper.getAccountType({ loginState })
  let userAgent = ua.getUserAgent()
  recommendInfo.forEach(recommItem => {
    if (
      recommItem.biz &&
      recommItem.biz[userAgent.iOS ? "ios" : "android"] &&
      recommItem.biz[userAgent.iOS ? "ios" : "android"][accountType]
    ) {
      let drm_activity_group = recommItem.biz[userAgent.iOS ? "ios" : "android"][accountType].drm_activity_group
      if (drm_activity_group && drm_activity_group.length > 0) {
        let filterdDrmActivity = drm_activity_group.filter(item => {
          return gamePropsAPI.checkTimeStatus(item.begin_time, item.end_time) == 1
        })[0]
        recommItem.biz.activity_tag = filterdDrmActivity && filterdDrmActivity.tag
        recommItem.biz.activity_desc = filterdDrmActivity && filterdDrmActivity.desc
      }
    }
  })
  return recommendInfo
}

/**
 * 商城推荐接口
 * @param params
 * @returns {Promise}
 */
export function getMallRecommendApi(params) {
  return new Promise((resolve, reject) => {
    let apiParams = {
      offerId: params.offerId || "1450000186"
    }

    let env = ""

    if (params.sandbox) {
      env = "sandbox."
    }

    let data = helper.extend(
      apiParams,
      commonParams,
      params,
      aes.encrypt(apiParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: "//" + env + "pay.qq.com/h5/store/mall.php",
        data
      })
      .then(res => {
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
  })
}

/**
 * 获得王者荣耀商城内数据总和
 * @param params
 * @returns {Promise<any>}
 */
export function getMallWzryData(params) {
  let url = `//${params.sandbox ? "sandbox.pay.qq.com" : "pay.qq.com"}${langs.WZRY_NEWS_SEARCH_URL_PATH}`

  return gameRecommNews({
    ...params,
    url,
    offerId: "1450000186",
    action: "getMallWzryData",
    pageIndex: 1,
    pageSize: 20
  })
}
/**
 * 预约专区
 * @param params
 * @param {String} params.pf
 * @param {String} params.sandbox
 * @param {Object} params.loginState
 * @returns {Promise<any>}
 */
export function getReservationRecommend(params) {
  return recommend({
    pf: params.pf,
    model: params.model,
    sandbox: params.sandbox,
    ...params.loginState
  })
}
/**
 * 某道具关联的推荐道具
 * @param params
 * @param {String} params.pf
 * @param {String} model
 * @param {String} params.sandbox
 * @param {String} params.product_id (groupid_buzid_itemId)
 * @param {Object} params.loginState
 * @returns {Promise<any>}
 */
export function getRecommendProductByItemId(params) {
  return recommend({
    pf: params.pf,
    model: "liveroom_product_recomm",
    sandbox: params.sandbox,
    product_id: params.productId,
    ...helper.getLoginState(params.loginState)
  })
}

export function contentRecommend(params) {
  return new Promise((resolve, reject) => {
    let apiParams = {
      offerId: params.offerId || "1450000186"
    }

    // eslint-disable-next-line no-unused-vars
    let env = params.sandbox ? "sandbox." : "",
      data = helper.extend(
        apiParams,
        commonParams,
        params,
        aes.encrypt(apiParams, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
      )

    delete data.sandbox
    delete data.url

    request
      .ajax({
        url: `//${env}pay.qq.com/${params.url}`,
        data,
        type: "get"
      })
      .then(res => {
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
  })
}

/**
 * 获取商城推荐内容数据
 * @param params
 * @returns {Promise<any>}
 */
export function getMallContentRecommendData(params) {
  return new Promise((resolve, reject) => {
    /**
     * 第一位数字代表号码态（qq/wx）， 其中0代表qq，1代表wx
     * 第二位数字代表系统（android/ios），其中0代表android，1代表ios
     */
    let uaMap = {
      qq_android: "00",
      qq_ios: "01",
      wx_android: "10",
      wx_ios: "11"
    }

    let userAgent = ua.getUserAgent()
    let pt = userAgent.QQ ? "qq" : "wx"

    pt += userAgent.iOS ? "_ios" : "_android"

    // let { recommendService, recommendActivityId, operationService, operationActivityId } = params
    contentRecommend({
      ...params,
      service: params.recommendService,
      activity_id: params.recommendActivityId,
      operation_service: params.operationService,
      operation_activity_id: params.operationActivityId,
      ua: uaMap[pt],
      action: "recommendContent",
      url: "txcz/node/api/mall/recommend"
    })
      .then(res => {
        if (res.ret !== 0) {
          reject(res)
        } else {
          resolve(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 获取商城直播内容推荐的数据
 * @param params
 */
export function getLiveContentRecommendData(params) {
  return contentRecommend({
    ...params,
    action: "recommendLive",
    url: "txcz/node/api/mall/recommend"
  })
}

/**
 * 获得内容详情
 * @param params
 */
export function getMallContentDetail(params) {
  return contentRecommend({
    ...params,
    action: "getContentDetail",
    url: "txcz/node/api/mall/content"
  })
}

//http://pay.qq.com/txcz/node/api/mall/recommend?action=recommendLive&offerId=1450019044&openid=2268265132&openkey=%4069jmC6yeg&session_id=uin&session_type=skey&wx_appid=wx951bdcac522929b6&pageSize=20&pageIndex=1
/**
 * 查最热的直播列表
 * @param params
 */
export function recommendLive(params) {
  return contentRecommend({
    ...params,
    action: "recommendLive",
    url: "txcz/node/api/mall/recommend"
  })
}

/**
 * 查询专区资讯推荐
 * @param params
 * activity_id，sceneId，service 资讯推荐模型
 * operation_service，operation_activity_id 运营推荐模型
 * ext 扩展字段。目前暂时没有用。
 */
export function getServiceZoneContentRecommendData(params) {
  return new Promise((resolve, reject) => {
    /**
     * 第一位数字代表号码态（qq/wx）， 其中0代表qq，1代表wx
     * 第二位数字代表系统（android/ios），其中0代表android，1代表ios
     */
    let uaMap = {
      qq_android: "00",
      qq_ios: "01",
      wx_android: "10",
      wx_ios: "11",
      _ios: "",
      _android: ""
    }

    let userAgent = ua.getUserAgent()
    let pt = userAgent.QQ ? "qq" : userAgent.weixin ? "wx" : ""

    pt += userAgent.iOS ? "_ios" : "_android"

    contentRecommend({
      ...params,
      service: params.service || "wsdnews",
      ua: params.operation_activity_id ? uaMap[pt] || "" : "",
      action: params.action || "recommendContent",
      url: "txcz/node/api/mall/recommend"
    })
      .then(res => {
        if (res.ret == 0 && res.data) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 获取当前用户支付过业务信息
 * @param params
 */
export function getUserPayGroupIds(params) {
  return new Promise((resolve, reject) => {
    recommend({
      pf: params.pf,
      model: modals.PAY.PAY_GROUPID,
      sandbox: params.sandbox,
      ...params.loginState
    })
      .then(res => {
        if (res.ret !== 0) {
          reject(res)
        } else {
          resolve(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 处理标签推荐的结果
 * 应该标签推荐base64编码过一层，所以不能复用之前处理的方法
 * @param result
 * @returns {Array}
 */
export function handleTagRecommendResult(result) {
  try {
    let labelList = []
    let labelStr = helper.base64decode(result[0] || "") || "{}"
    let labelObj = JSON.parse(labelStr)
    Object.keys(labelObj)
      .sort((item1, item2) => parseInt(item1) - parseInt(item2))
      .forEach(key => {
        labelList.push(labelObj[key])
      })
    return labelList
  } catch (error) {
    return []
  }
}
